import { Palette, Users, ShieldCheck, MapPin } from "lucide-react";

const ITEMS = [
  {
    icon: Palette,
    title: "Pacific-Inspired Designs",
    desc:
      "Authentic Samoan, Tongan and Cook Islands motifs designed in collaboration with you — never generic, always meaningful.",
  },
  {
    icon: Users,
    title: "Bulk Group Ordering",
    desc:
      "Built for groups from 10 to 500+. Volume pricing, sizing across S–7XL, name and role personalisation included.",
  },
  {
    icon: ShieldCheck,
    title: "Professional Appearance",
    desc:
      "Premium polo fabric, embroidered or full-colour print, finished to suit Sunday service, conferences and formal events.",
  },
  {
    icon: MapPin,
    title: "NZ-Based Service",
    desc:
      "Auckland-based studio. Talk directly to your designer in person, on the phone, or by WhatsApp — no offshore call centres.",
  },
];

export default function WhyChoose() {
  return (
    <section
      id="why"
      data-testid="why-choose-section"
      className="py-20 md:py-28 bg-zinc-950 border-y border-zinc-900"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-12">
        <div className="text-center max-w-3xl mx-auto">
          <p className="text-xs uppercase tracking-[0.3em] text-gold font-semibold">
            Why teams choose us
          </p>
          <h2 className="mt-3 font-display uppercase text-3xl md:text-5xl tracking-tight leading-[0.95]">
            Why Choose <span className="text-teal-400">Tribal Designz</span>
          </h2>
          <p className="mt-4 text-zinc-400 max-w-2xl mx-auto">
            We're not just printing polos — we're helping Pacific churches and
            communities show up with pride.
          </p>
        </div>

        <div className="mt-14 grid sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {ITEMS.map((it, i) => {
            const Icon = it.icon;
            return (
              <article
                key={it.title}
                data-testid={`why-card-${i}`}
                className="group bg-zinc-900 border border-zinc-800 p-7 hover:border-teal-400/50 transition-colors"
              >
                <div className="w-12 h-12 bg-teal-400/10 border border-teal-400/30 grid place-items-center group-hover:bg-teal-400 group-hover:text-zinc-950 transition-all">
                  <Icon size={22} className="text-teal-400 group-hover:text-zinc-950" />
                </div>
                <h3 className="mt-5 font-display uppercase text-xl tracking-tight">
                  {it.title}
                </h3>
                <p className="mt-3 text-sm text-zinc-400 leading-relaxed">{it.desc}</p>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
}
